import { useSmartQuery } from "@shared/api/queries/hooks";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { callCenterPerformanceApi } from "./api";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";

export const useSummaryDashboard = (createdBy: any,year: number, month: number) => {
  const remoteUtilityId = getRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.callCenter.performance.summaryDashboard(year, month),
    () =>
      callCenterPerformanceApi.getSummaryDashboard(remoteUtilityId, createdBy,year, month),
    {
      enabled: !!remoteUtilityId && !!createdBy,
    }
  );
};

export const useConsumerWeeklyReport = (createdBy: any) => {
  const remoteUtilityId = getRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.callCenter.performance.consumerWeeklyReport(),
    () =>
      callCenterPerformanceApi.getConsumerWeeklyReport(remoteUtilityId, createdBy),
    {
      enabled: !!remoteUtilityId && !!createdBy,
    }
  );
};
